import { Checkbox, Form, Input, InputNumber, Mentions, Select } from 'antd'
import React, { useCallback, useMemo, useState } from 'react'
import {EnterOutlined} from "@ant-design/icons";

export default function SearchItem({ fieldName, parameters, form }) {
  const deterministic = Form.useWatch(['actions', fieldName, 'action', 'data', 'deterministic'], form)

  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr.map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item
        label={'A partir de'}
        rules={[
          {
            required: true,
            message: 'É preciso escolher um parametro do gatilho',
          },
        ]}
        name={[fieldName, 'action', 'data', 'searchText']}
      >
        <Select placeholder={'Parametro para pesquisa'} options={available} />
      </Form.Item>
      <Form.Item
        label={'Limite de produtos'}
        name={[fieldName, 'action', 'data', 'productLimit']}
      >
        <InputNumber placeholder={'Limite de produtos'} type='number' max={20} />
      </Form.Item>
      <Form.Item
        name={[fieldName, 'action', 'data', 'mustSendImage']}
        valuePropName="checked"
      >
        <Checkbox>
          Enviar imagem do produto
        </Checkbox>
      </Form.Item>
      <Form.Item
        name={[fieldName, 'action', 'data', 'deterministic']}
        valuePropName="checked"
      >
        <Checkbox>
          Desabilitar busca com AI
        </Checkbox>
      </Form.Item>
      {deterministic && <Form.Item
        name={[fieldName, 'action', 'data', 'deterministicFields']}
        label={"Limitar busca apenas aos campos abaixo"}
      >
        <Select
          maxCount={20}
          mode={'multiple'}
          options={[
            {
              label: 'Nome',
              value: 'name',
            },
            {
              label: 'Descrição',
              value: 'description',
            }
          ]}
          suffixIcon={<EnterOutlined/>}
          placeholder="Escolha os campos que devem ser usados na busca deterministica"
        />
      </Form.Item>}
    </>
  )
}
